/* istanbul ignore file */
export * from './CriteoProductCard';
